import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 16,
    paddingVertical: 20,
    paddingHorizontal: 16,
    borderRadius: theme.radius.m,
    backgroundColor: theme.palette.mono100,
  },
  text: {
    flex: 1,
    rowGap: 4,
  },
  title: {
    fontSize: 14,
    lineHeight: 20,
    color: theme.palette.mono800,
    fontVariant: ['tabular-nums'],
    fontFamily: theme.fonts.medium,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 16,
    color: theme.palette.mono600,
    fontVariant: ['tabular-nums'],
    fontFamily: theme.fonts.regular,
  },
  badges: {
    flexDirection: 'row',
    columnGap: 4,
  },
  badge: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: theme.radius.s,
    borderWidth: 1,
    borderColor: theme.palette.mono300,
    backgroundColor: theme.palette.white,
  },
  badgeText: {
    fontSize: 12,
    lineHeight: 16,
    color: theme.palette.mono800,
    fontFamily: theme.fonts.regular,
  },
});
